import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20.418} height={10.809} {...props}>
    <path
      data-name="Arrow Expand 20"
      d="M1.218 0a1.216 1.216 0 0 1 .835.331l8.09 7.594 8.23-7.6a1.218 1.218 0 1 1 1.654 1.784l-9.064 8.376a1.218 1.218 0 0 1-1.661-.007L.384 2.109A1.219 1.219 0 0 1 1.218.002Z"
      fill="#f2f2f2"
    />
  </svg>
);

export default SvgComponent;
